import axios from 'axios';
import { toast } from 'components/elements/molecules/Toast/Toast';
import { updatePropagateStatus } from './classRooms';

export function syncCourses(payload) {
  return (dispatch) => {
    return axios
      .post('/api/duplicateCourse/syncCourses', payload)
      .then((res) => {
        const data = res.data;
        return data;
      })
      .catch((error) => {
        console.log('Error while syncing course', error);
        toast('Error while syncing course', {
          type: 'error',
        });
        throw error;
      });
  };
}

// Dry run of syncMasterCourses - returns what each section would receive,
// changes nothing.
export function previewSyncMasterCourses(payload) {
  return (dispatch) => {
    return axios
      .post('/api/duplicateCourse/previewSyncMasterCourses', payload)
      .then((res) => res.data.preview)
      .catch((error) => {
        console.log('Error while previewing master course sync', error);
        throw error;
      });
  };
}

// Admin-only: the recorded change log for a master course (open changes, or
// all with includeSynced), shown beside the live preview while it is checked.
// Resolves to the log laid out like the preview: [{ title, items: [rows] }],
// each open change marked as in the live preview or not, and what the
// preview shows that the log never recorded placed in line, flagged notInLog.
export function getMasterCourseChanges(masterCourseId, includeSynced = false) {
  return (dispatch) => {
    return axios
      .get('/api/duplicateCourse/masterCourseChanges', {
        params: { masterCourseId, includeSynced },
      })
      .then((res) => res.data.groups || [])
      .catch((error) => {
        console.log('Error while fetching master course changes', error);
        throw error;
      });
  };
}

export function syncMasterCourses(payload) {
  return (dispatch) => {
    dispatch(updatePropagateStatus(payload.masterCourseId, false));

    return axios
      .post('/api/duplicateCourse/syncMasterCourses', payload)
      .then((res) => {
        const data = res.data;

        return data;
      })
      .catch((error) => {
        console.log('Error while syncing master course', error);
        toast('Error while syncing master course', {
          type: 'error',
        });
        throw error;
      });
  };
}
